// extracted by mini-css-extract-plugin
export default {"primaryColorBase":"#085","primaryColorLight":"#049d64","primaryColorLighter":"#12dc90","primaryColorLightest":"#4febb1"};